<template>
  <div class="share-network">
    <!-- 首屏 banner -->
    <div class="section-banner">
      <div class="banner-main">
        <div class="banner-row">
          <div class="banner-left">
            <div class="banner-title move">共享网络</div>
            <div class="banner-subtitle move delay-100"">局域网资源，一键共享给团队</div>
            <div class="banner-desc move delay-200">
              对指定内网地址及端口发起授权共享，被授权成员即可通过统一共享地址，安全访问目标设备及其指定服务端口，实现内网资源的高效协同。
            </div>
            <div class="banner-btns">
              <div class="btn-primary" @click="goDownload">立即体验</div>
              <div class="btn-ghost" @click="goDoc">查看文档</div>
            </div>
          </div>
          <img class="banner-pic" :src="bannerPic" alt="" />
        </div>
        <div class="banner-features">
          <div class="feature-item">
            <img class="feature-icon" :src="featEasy" alt="" />
            <div class="feature-text">
              <div class="feature-title">操作便捷</div>
              <div class="feature-sub">任意设备即可发起共享</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="featPerm" alt="" />
            <div class="feature-text">
              <div class="feature-title">权限可控</div>
              <div class="feature-sub">成员授权、精细化控制</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="featUnified" alt="" />
            <div class="feature-text">
              <div class="feature-title">统一管理</div>
              <div class="feature-sub">共享网络IP，统一访问</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 核心能力 -->
    <div class="section-adv">
      <div class="adv-main">
        <div class="section-title move">核心优势</div>
        <div class="section-sub move delay-100">共享网络，灵活安全</div>
        <div class="adv-grid">
          <div class="adv-card move" v-for="(item, index) in advList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <img class="adv-icon" :src="item.icon" alt="" />
            <div class="adv-title">{{ item.title }}</div>
            <div class="adv-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 工作原理 -->
    <div class="section-flow">
      <div class="flow-main">
        <div class="section-title move">工作原理</div>
        <div class="section-sub move delay-100">将设备局域网的任意IP及端口共享给成员，授权成员可访问到目标设备或服务</div>
        <div class="flow-grid">
          <template v-for="(item, index) in flowList">
            <div class="flow-card move" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
              <div class="flow-top">
                <img :src="item.img" alt="" />
              </div>
              <div class="flow-title">{{ item.title }}</div>
              <div class="flow-desc">{{ item.desc }}</div>
            </div>
            <div v-if="index < flowList.length - 1" class="flow-arrow" :key="'arrow-' + index">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                <path d="M8 8l6 7-6 7" stroke="#3772ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16 8l6 7-6 7" stroke="#3772ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 使用方式（深色区） -->
    <div class="section-usage">
      <div class="usage-main">
        <div class="section-title move">使用方式</div>
        <div class="usage-grid">
          <div class="usage-card">
            <div class="usage-illus">
              <img :src="usageWhole" alt="" />
            </div>
            <div class="usage-title">整机共享</div>
            <div class="usage-desc">共享目标设备的完整IP，适用于文件服务器、数据库、虚拟机等需要全面访问的场景</div>
          </div>
          <div class="usage-card">
            <div class="usage-illus">
              <img :src="usagePort" alt="" />
            </div>
            <div class="usage-title">端口共享</div>
            <div class="usage-desc">仅共享指定端口的服务，例如OA、ERP、SSH、Web等，最小化暴露，按需访问</div>
          </div>
          <div class="usage-card">
            <div class="usage-illus">
              <img :src="usageMember" alt="" />
            </div>
            <div class="usage-title">成员授权访问</div>
            <div class="usage-desc">邀请成员并为其分配访问权限，可定向成员访问哪些共享目标，实现精细化管控</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 应用场景 -->
    <div class="section-scene">
      <div class="scene-main">
        <div class="section-title move">应用场景</div>
        <div class="scene-grid">
          <div class="scene-card move" v-for="(item, index) in sceneList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <div class="scene-img-wrap">
              <img :src="item.img" alt="" />
            </div>
            <div class="scene-title">{{ item.title }}</div>
            <div class="scene-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 CTA -->
    <div class="section-cta">
      <img class="cta-overlay" :src="ctaOverlay" alt="" />
      <div class="cta-main">
        <div class="cta-title">立即开始你的共享网络体验</div>
        <div class="cta-sub">把局域网内设备与服务，安全有序的共享给团队成员</div>
        <div class="btn-primary cta-btn" @click="goDownload">免费体验</div>
      </div>
    </div>

    <Foot></Foot>
  </div>
</template>

<script>
import Foot from '@/components/Foot.vue'

export default {
  name: 'ShareNetwork',
  components: {
    Foot,
  },
  data: function () {
    return {
      bannerPic: require('@/assets/share_network/banner.webp'),
      featEasy: require('@/assets/share_network/feat_easy.png'),
      featPerm: require('@/assets/share_network/feat_perm.png'),
      featUnified: require('@/assets/share_network/feat_unified.png'),
      // 使用方式插图用 SVG（透明背景，黑渐变能保留，PNG 导出会丢失）
      usageWhole: require('@/assets/share_network/usage_whole.png'),
      usagePort: require('@/assets/share_network/usage_port.png'),
      usageMember: require('@/assets/share_network/usage_member.png'),
      ctaOverlay: require('@/assets/introduce/cta_bg.png'),
      advList: [
        {
          icon: require('@/assets/share_network/adv_flex.png'),
          title: '灵活共享',
          desc: '支持共享指定设备或设备所在的局域网地址',
        },
        {
          icon: require('@/assets/share_network/adv_port.png'),
          title: '限定端口',
          desc: '灵活配置端口权限，支持单个及范围端口共享',
        },
        {
          icon: require('@/assets/share_network/adv_grant.png'),
          title: '灵活授权',
          desc: '可对各成员各共享灵活分配权限',
        },
        {
          icon: require('@/assets/share_network/adv_team.png'),
          title: '团队协作',
          desc: '适合多人共同访问内网资源',
        },
        {
          icon: require('@/assets/share_network/adv_isolate.png'),
          title: '安全隔离',
          desc: '中心式共享，成员间网络隔离',
        },
      ],
      flowList: [
        {
          img: require('@/assets/share_network/flow1.png'),
          title: '绑定设备',
          desc: '登录账号即可绑定您的设备',
        },
        {
          img: require('@/assets/share_network/flow2.png'),
          title: '创建共建',
          desc: '生成共享网络规则与IP',
        },
        {
          img: require('@/assets/share_network/flow3.png'),
          title: '邀请授权',
          desc: '邀请成员并为其分配访问权限',
        },
        {
          img: require('@/assets/share_network/flow4.png'),
          title: '成员访问',
          desc: '成员通过共享网络IP访问目标服务',
        },
      ],
      sceneList: [
        {
          img: require('@/assets/share_network/scene1.webp'),
          title: '团队文件共享',
          desc: '团队成员远程访问NAS或文件服务器，安全共享文件与资料',
        },
        {
          img: require('@/assets/share_network/scene2.webp'),
          title: 'OA / ERP协同访问',
          desc: '发布OA/ERP/CRM等系统，随时随地高效办公',
        },
        {
          img: require('@/assets/share_network/scene3.webp'),
          title: '娱乐媒体共享',
          desc: '共享影视或音乐服务，成员可通过P2P通道畅享高质体验',
        },
        {
          img: require('@/assets/share_network/scene4.webp'),
          title: '团队开发',
          desc: '共享仓库服务，成员通过共享网络拉取或提交代码',
        },
      ],
    }
  },
  methods: {
    goDownload: function () {
      if (this.$route.path !== '/download') {
        this.$router.push('/download')
      }
    },
    goDoc: function () {
      window.open('https://iepose.com/helpcenter_v3/')
    },
    // 滚动检查：进入视口的 .move 元素加 move-active，触发入场动画（同首页模式）
    checkInView: function (animatedElements) {
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight
      animatedElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top
        const elementBottom = element.getBoundingClientRect().bottom
        const isInView = elementTop < windowHeight - 100 && elementBottom > 0
        if (isInView) {
          element.classList.add('move-active')
        }
      })
    },
  },
  mounted: function () {
    const animatedElements = document.querySelectorAll('.move')
    // 首屏元素立即检查一次（页面刚加载时尚未触发 scroll，避免首屏内容空白）
    this.$nextTick(() => {
      this.checkInView(animatedElements)
    })
    window.addEventListener('scroll', () => {
      this.checkInView(animatedElements)
    })
  },
}
</script>

<style scoped lang="less">
.share-network {
  width: 100%;

  .section-title {
    font-size: 40px;
    font-weight: 700;
    color: #1d1f24;
    text-align: center;
  }

  .section-sub {
    margin-top: 12px;
    font-size: 24px;
    line-height: 36px;
    color: #777e90;
    text-align: center;
  }

  .btn-primary {
    width: 160px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #ffffff;
    font-size: 18px;
    border-radius: 8px;
    background: #3772ff;
    cursor: pointer;
  }

  .btn-primary:hover {
    opacity: 0.9;
  }

  /* ---------- 首屏 ---------- */
  .section-banner {
    padding-top: 122px;
    padding-bottom: 70px;
    // 横向渐变：左蓝 → 右暖白
    background: linear-gradient(90deg, #e5edff 0%, #e8ecff 50%, #fff5e9 100%);

    .banner-main {
      width: 1280px;
      margin: 0 auto;
    }

    .banner-row {
      position: relative;
      height: 328px;

      .banner-pic {
        position: absolute;
        right: 0;
        top: -39px;
        width: 563px;
        height: 400px;
        flex-shrink: 0;
      }
    }

    .banner-left {
      width: 660px;
      flex-shrink: 0;
    }

    .banner-title {
      width: fit-content;
      font-size: 64px;
      font-weight: 700;
      line-height: 72px;
      background: linear-gradient(
        90deg,
        #3772ff 0%,
        #aa56ff 35%,
        #ff6838 70%,
        #ff9924 100%
      );
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .banner-subtitle {
      margin-top: 13px;
      font-size: 44px;
      font-weight: 700;
      line-height: 66px;
      color: #1d1f24;
    }

    .banner-desc {
      margin-top: 9px;
      width: 560px;
      font-size: 20px;
      line-height: 29px;
      color: #777e90;
    }

    .banner-btns {
      display: flex;
      margin-top: 33px;
    }

    .btn-ghost {
      margin-left: 16px;
      width: 160px;
      height: 48px;
      line-height: 46px;
      text-align: center;
      font-size: 18px;
      color: #3772ff;
      border: 1px solid #3772ff;
      border-radius: 8px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .btn-ghost:hover {
      background: rgba(55, 114, 255, 0.08);
    }

    .banner-features {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 80px;
      height: 120px;
      padding: 0 67px;
      background: rgba(255, 255, 255, 0.4);
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-radius: 20px;
      box-sizing: border-box;
      // 毛玻璃悬浮条：半透明白 + 背景模糊
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
      box-shadow: 0 8px 24px rgba(23, 33, 94, 0.06);
    }

    .feature-item {
      display: flex;
      align-items: center;

      .feature-icon {
        width: 60px;
        height: 60px;
      }

      .feature-text {
        margin-left: 12px;

        .feature-title {
          font-size: 24px;
          font-weight: 700;
          line-height: 36px;
          color: #1d1f24;
        }

        .feature-sub {
          margin-top: 2px;
          font-size: 16px;
          line-height: 24px;
          color: #777e90;
        }
      }
    }
  }

  /* ---------- 核心能力 ---------- */
  .section-adv {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #ffffff;
    box-sizing: border-box;

    .adv-main {
      width: 1280px;
      margin: 0 auto;
    }

    .adv-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }

    .adv-card {
      width: 240px;
      min-height: 220px;
      padding: 33px 24px 0;
      background: #f7f9fe;
      border-radius: 16px;
      box-sizing: border-box;

      .adv-icon {
        width: 48px;
        height: 48px;
        display: block;
      }

      .adv-title {
        margin-top: 24px;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        color: #1d1f24;
      }

      .adv-desc {
        margin-top: 10px;
        font-size: 14px;
        line-height: 21px;
        color: #777e90;
      }
    }
  }

  /* ---------- 工作原理 ---------- */
  .section-flow {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #f7f9fe;
    box-sizing: border-box;

    .flow-main {
      width: 1280px;
      margin: 0 auto;
    }

    .flow-grid {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 50px;
    }

    .flow-card {
      width: 302px;
      padding: 30px 30px 0;
      // 卡片固定 300 高，文案行数不同也能等高
      min-height: 300px;
      background: #ffffff;
      border-radius: 20px;
      box-shadow: 0 4px 30px 0 rgba(55, 114, 255, 0.05);
      box-sizing: border-box;

      .flow-top {
        height: 140px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        img {
          width: 160px;
          height: 140px;
          object-fit: contain;
        }
      }

      .flow-title {
        margin-top: 20px;
        font-size: 24px;
        font-weight: 700;
        line-height: 34px;
        color: #1d1f24;
        text-align: center;
      }

      .flow-desc {
        // 底部留白 14px：两行文案时内容 286，配合 min-height 300 全卡等高；40px 会把卡顶超
        margin: 10px auto 14px;
        font-size: 16px;
        line-height: 26px;
        color: #777e90;
        text-align: center;
      }
    }

    .flow-arrow {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }

  /* ---------- 使用方式（深色区） ---------- */
  .section-usage {
    padding-top: 60px;
    padding-bottom: 82px;
    background: linear-gradient(180deg, #1d1f24 0%, #192238 100%);
    box-sizing: border-box;

    .usage-main {
      width: 1280px;
      margin: 0 auto;
    }

    .section-title {
      color: #ffffff;
    }

    .usage-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }

    .usage-card {
      width: 400px;
      padding-bottom: 36px;
      // 卡片背景用白色 10% 渐变，插图透明底，面板感由卡片背景透出
      background: linear-gradient(180deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0) 100%);
      border-radius: 20px;
      box-sizing: border-box;

      .usage-illus {
        width: 400px;
        height: 260px;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        overflow: hidden;

        img {
          display: block;
          flex-shrink: 0;
          // 2 倍图 800x520，高清屏下更清晰
          width: 400px;
          height: 260px;
        }
      }

      .usage-title {
        margin-top: 20px;
        // 文本左右间距 30 / 24
        padding: 0 24px 0 30px;
        font-size: 30px;
        font-weight: 700;
        line-height: 42px;
        color: #ffffff;
        text-align: left;
      }

      .usage-desc {
        margin-top: 10px;
        // 左 30 右 24
        padding: 0 24px 0 30px;
        font-size: 16px;
        line-height: 26px;
        color: #b1b5c4;
        text-align: left;
      }
    }
  }

  /* ---------- 应用场景 ---------- */
  .section-scene {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #ffffff;
    box-sizing: border-box;

    .scene-main {
      width: 1280px;
      margin: 0 auto;
    }

    .scene-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }

    .scene-card {
      width: 302px;
      background: #ffffff;
      box-sizing: border-box;

      .scene-img-wrap {
        height: 180px;
        border-radius: 16px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          }
      }

      .scene-title {
        margin-top: 19px;
        // 文本左右 12px
        padding: 0 12px;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        color: #1d1f24;
      }

      .scene-desc {
        margin-top: 13px;
        // 文本左右 12px
        padding: 0 12px;
        font-size: 14px;
        line-height: 21px;
        color: #777e90;
      }
    }
  }

  /* ---------- 底部 CTA ---------- */
  .section-cta {
    position: relative;
    padding-top: 67px;
    padding-bottom: 60px;
    background: #3772ff;
    overflow: hidden;
    box-sizing: border-box;

    .cta-overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      mix-blend-mode: overlay;
      opacity: 0.6;
      pointer-events: none;
    }

    .cta-main {
      position: relative;
      width: 1280px;
      margin: 0 auto;
      text-align: center;
    }

    .cta-title {
      font-size: 40px;
      font-weight: 700;
      line-height: 60px;
      color: #ffffff;
    }

    .cta-sub {
      margin-top: 12px;
      font-size: 18px;
      color: #ffffff;
    }

    .cta-btn {
      margin: 26px auto 0;
      width: 168px;
      height: 48px;
      line-height: 48px;
      font-size: 19px;
      background: #ffffff;
      color: #3772ff;
    }
  }

  /* ---------- 滚动入场动画（同首页模式） ---------- */
  .move {
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  }
  .move-active {
    opacity: 1;
    transform: translateY(0);
  }
  /* 为不同元素设置不同的延迟，创建层次感 */
  .delay-100 {
    transition-delay: 0.1s;
  }
  .delay-200 {
    transition-delay: 0.2s;
  }
  .delay-300 {
    transition-delay: 0.3s;
  }
}
</style>
